export default __webpack_public_path__ + "static/media/hotbargaindealllogo.754119a8.png";